import slice from "./filtersSlice";

export default slice.reducer;
